import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useSyncStore = defineStore('sync', () => {
  const isOnline = ref(navigator.onLine)
  const pendingWrites = ref(0)

  window.addEventListener('online', () => { isOnline.value = true })
  window.addEventListener('offline', () => { isOnline.value = false })

  const status = computed(() => {
    if (!isOnline.value) return 'offline'
    if (pendingWrites.value > 0) return 'pending'
    return 'connected' //synced
  })

  return { isOnline, pendingWrites, status }
})
